import { Server, Award, Code, Users, Cloud, Database, Network, Settings, Monitor, Layers, Palette } from 'lucide-react';

let img_version="1.0.2";

export const project_categories = [
    {
      category: "Enterprise Infrastructure",
      icon: <Server className="me-2" size={20} />,
      projects: [
        {
          name: "AWS MQ + RDMQ HA",
          description: "High availability messaging infrastructure bridging AWS MQ and RDMQ for enterprise hybrid cloud environments",
          url: "https://github.com/chris17453/aws-mq-rdmq-ha",
          tech: ["AWS MQ", "RDMQ", "Python"],
          image: `/static/rqdm.png?v=${img_version}`
        },
        {
          name: "Homelab Infrastructure",
          description: "Enterprise-grade home infrastructure with 3.5TB RAM, 306 cores running production-equivalent environments",
          links: [
            { url: "https://github.com/chris17453/homelab", type: "github", label: "Code" }
          ],
          tech: ["Enterprise Hardware", "RedHat", "VMware"],
          image: `/static/homelab.png?v=${img_version}`
        },
        {
          name: "Cloud Seeder",
          description: "Automated Rancher Kubernetes cluster deployment in VMware environments",
          url: "https://github.com/chris17453/cloud-seeder",
          tech: ["Kubernetes", "VMware", "Rancher"],
          image: `/static/cloud-seeder.png?v=${img_version}`
        },
        {
          name: "VOIP Integration",
          description: "Voice agent modules for SIP/FreePBX enterprise telephony systems",
          url: "https://github.com/chris17453/echomatrix",
          tech: ["SIP", "FreePBX", "VOIP"],
          image: `/static/voip.jpg?v=${img_version}`
        }
      ]
    },
    {
      category: "AI/ML Innovation",
      icon: <Award className="me-2" size={20} />,
      projects: [
        {
          name: "CGAN MNIST Refactored",
          description: "Custom AI model training for handwritten text recognition with AI-generated font capabilities",
          url: "https://github.com/chris17453/cgan-MNIST-refactored",
          tech: ["TensorFlow", "Python", "CGAN"],
          image: "/static/minst.gif"
        },
        {
          name: "WordPress AI Generator",
          description: "Controlled AI article generation for WordPress with precision prompting and content management",
          url: "https://github.com/chris17453/wp-rss-article-re-gen",
          tech: ["WordPress", "AI APIs", "PHP"],
          image: "/static/ai-news.png"
        },
        {
          name: "Image to SVG Converter",
          description: "AI-powered tool for converting images to scalable vector graphics",
          url: "https://github.com/chris17453/imagetosvg",
          tech: ["Python", "AI", "SVG Processing"],
          image: "/static/img2svg.svg"
        },
        {
          name: "Azure AI Foundry RAG Document Chat Demo",
          description: "A MVP to show how to utilize Azure's AI services to perform RAG on documents",
          url: "https://github.com/chris17453/AzureFoundryDocumentChatApp",
          tech: [".NET", "Azure AI Factory", "RAG", "Document Processing"],
          image: "/static/azure-foundry-chat.png"
        }

        
      ]
    },
    {
      category: "Developer Productivity",
      icon: <Code className="me-2" size={20} />,
      projects: [
        {
          name: "Resumate",
          description: "Command-line utility for building a professional Resume from yaml",
          url: "https://github.com/chris17453/resumate",
          tech: ["Python", "CLI"],
          image: "/static/resumate.png"
        },

        {
          name: "Flort CLI Tool",
          description: "Command-line utility for concatenating files optimized for AI processing workflows",
          url: "https://github.com/watkinslabs/flort",
          tech: ["Python", "CLI"],
          image: "/static/flort-card.png"
        },
        {
          name: "TTY to GIF",
          description: "Terminal session recorder that creates animated GIFs from text output",
          url: "https://github.com/chris17453/ttygif",
          tech: ["Python", "Terminal","Video","Demo"],
          image: "/static/ttygif.webp"
        },       
        {
          name: "TTYVID",
          description: "Terminal session recorder that creates animated GIFs from text output",
          url: "https://github.com/watkinslabs/ttyvid",
          tech: ["Rust", "Terminal","Video","Demo"],
          image: "/static/ttyvid.png"
        },
        {
          name: "CLI RAG",
          description: "A Dot net agentic RAG tool for local inference with a local database ",
          url: "https://github.com/chris17453/cli-rag",
          tech: [".NET", "Terminal","RAG","Agentic AI"],
          image: "/static/cli-rag.png"
        },
        {
          name: "VS Code Extensions",
          description: "File transfer utility and Flort integration for VS Code, plus 50+ published themes",
          url: "https://marketplace.visualstudio.com/search?term=watkins%20labs&target=VSCode&category=All%20categories&sortBy=Relevance",
          tech: ["TypeScript", "VS Code API"],
          image: "/static/theme.png"
        }
      ]
    },
    {
      category: "Database Innovation",
      icon: <Users className="me-2" size={20} />,
      projects: [
        {
          name: "DDB Database Engine",
          description: "Stateless database engine providing SQL interface for flat files, adopted by multiple global organizations. E-Trade, IBM, HP",
          url: "https://github.com/chris17453/ddb",
          tech: ["Python", "SQL", "File Processing"],
          image: "/static/ddb.png"
        }
      ]
    },
    {
             category: "Creativity",
             icon: <Palette className="me-2" size={20} />,
             projects: [
               {
                 name: "AI Job Wars",
                 description: "I wrote a videogame, (well before AI coding was a thing). A 2D shooter built from scratch with custom game engine, rendering system, and asset management - all in pure JavaScript with no libraries",
                 links: [
                   { url: "https://aijobwars.com", type: "live", label: "Play Game" },
                   { url: "https://github.com/chris17453/aijobwars", type: "github", label: "Code" }
                 ],
                 tech: ["JavaScript", "Game Engine", "Canvas API", "Custom Renderer"],
                 image: `/static/aijobwars.png?v=${img_version}`
               },
        {
          name: "Digital Amber",
          description: "I wrote a book! My first published work. It's a speculative look into AI and the human condition over time. Written with code, automation and AI. \n Available on Amazon, or read online for free, audio book on youtube.",
          links: [
            { url: "https://github.com/chris17453/digital_amber", type: "github", label: "GitHub"},
            { url: "https://a.co/d/gQouRhh", type: "Amazon", label: "Amazon"},
          ],
          
          tech: ["Python", "AI", "Kindle", "Audio Book","YouTube"],
          image: "/static/book-card.webp"

        }
      ]
    }
  ];
  


